import { render } from "./BombCard.vue?vue&type=template&id=cd6b5082"
import script from "./BombCard.vue?vue&type=script&lang=js"
export * from "./BombCard.vue?vue&type=script&lang=js"

import "./BombCard.vue?vue&type=style&index=0&id=cd6b5082&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection,QBtn});
